module.exports = __webpack_public_path__ + "static/media/loading17.020189f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading17.png
// module id = 202
// module chunks = 0